"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENUMS = exports.CONSTANTS = void 0;
// ENUMS
var appIds_enum_1 = require("./enums/appIds.enum");
var auth_enum_1 = require("./enums/auth.enum");
var externalServices_enum_1 = require("./enums/externalServices.enum");
var permission_enum_1 = require("./enums/permission.enum");
var token_enum_1 = require("./enums/token.enum");
var user_enum_1 = require("./enums/user.enum");
// CONSTANTS
var appIds_constant_1 = require("./constants/appIds.constant");
var permissions_constant_1 = require("./constants/permissions.constant");
exports.CONSTANTS = {
    AppIdsArr: appIds_constant_1.AppIdsArr,
    ScopeLevelArr: permissions_constant_1.ScopeLevelArr,
    SCOPE_LEVEL_ADMIN: permissions_constant_1.SCOPE_LEVEL_ADMIN,
    SCOPE_LEVEL_SUPER: permissions_constant_1.SCOPE_LEVEL_SUPER,
    TE_ROOT_USER: permissions_constant_1.TE_ROOT_USER,
    SERVICE_ACCOUNT: permissions_constant_1.SERVICE_ACCOUNT,
};
exports.ENUMS = {
    EUserAllowJavaClientAccess: user_enum_1.EUserAllowJavaClientAccess,
    EUserVisibility: user_enum_1.EUserVisibility,
    EAppId: appIds_enum_1.EAppId,
    ETokenType: token_enum_1.ETokenType,
    EAuth: auth_enum_1.EAuth,
    EPermissionTypes: permission_enum_1.EPermissionTypes,
    EExternalServiceMethods: externalServices_enum_1.EExternalServiceMethods,
    EExternalServices: externalServices_enum_1.EExternalServices,
    EScopeLevel: permission_enum_1.EScopeLevel,
};
